import { std as m_std, mean as m_mean } from 'mathjs'

Number.prototype.countDecimals = function () {
  if(Math.floor(this.valueOf()) === this.valueOf()) return 0;
  return this.toString().split(".")[1].length || 0; 
}

export function std (a){
  return m_std(a)
}

export function mean (a){
  return m_mean(a)
}